import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7166
 *
 * @param {SvgIconProps} props - svg props
 */
export const AddCircleOutlineIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M13.1 7C13.1 6.72386 12.8761 6.5 12.6 6.5H11.4C11.1239 6.5 10.9 6.72386 10.9 7V10.9H7C6.72386 10.9 6.5 11.1239 6.5 11.4V12.6C6.5 12.8761 6.72386 13.1 7 13.1H10.9V17C10.9 17.2761 11.1239 17.5 11.4 17.5H12.6C12.8761 17.5 13.1 17.2761 13.1 17V13.1H17C17.2761 13.1 17.5 12.8761 17.5 12.6V11.4C17.5 11.1239 17.2761 10.9 17 10.9H13.1V7ZM12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1ZM12 20.8C7.149 20.8 3.2 16.851 3.2 12C3.2 7.149 7.149 3.2 12 3.2C16.851 3.2 20.8 7.149 20.8 12C20.8 16.851 16.851 20.8 12 20.8Z' fill={color}/>
        </SvgIcon>
    )
}

export default AddCircleOutlineIcon
